const initBlock = function( $block ) {
	$block.find( '.lp-marquee__track' ).each( function() {
		const $track = $( this );
		const $group = $track.children( '.lp-marquee__group' ).first();
		if ( $group.length ) { $track.append( $group.clone() ); } // duplicate for seamless -50% loop
	} );
};

app.loadBlock( initBlock, 'section-lp-packages', '.section-lp-packages' );

// if ( module.hot ) {
// 	module.hot.accept();
// }
